import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumProcessIngredientSource implements BaseEnumType {
  private static allValues: EnumProcessIngredientSource[] = []; // make sure this is top-most
  
  public static stock = new EnumProcessIngredientSource(0, "Stock", "enum_process_ingredient_source_stock");
  public static processSameBatch = new EnumProcessIngredientSource(1, "ProcessSameBatch", "enum_process_ingredient_source_process_same_batch");
  public static processOtherBatch = new EnumProcessIngredientSource(2, "ProcessOtherBatch", "enum_process_ingredient_source_process_other_batch");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumProcessIngredientSource.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isStock() { return this === EnumProcessIngredientSource.stock; }
  public isProcessSameBatch() { return this === EnumProcessIngredientSource.processSameBatch; }
  public isProcessOtherBatch() { return this === EnumProcessIngredientSource.processOtherBatch; }

  public static getValues(): readonly EnumProcessIngredientSource[] {
    return EnumProcessIngredientSource.allValues;
  }

  public static getValuesExcept0(): readonly EnumProcessIngredientSource[] {
    return EnumProcessIngredientSource.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumProcessIngredientSource {
    const found = EnumProcessIngredientSource.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumProcessIngredientSource - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumProcessIngredientSource): EnumProcessIngredientSource {
    const found = name ? EnumProcessIngredientSource.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumProcessIngredientSource - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumProcessIngredientSource>): boolean {
    return this.key === other?.key;
  }
}